<div class="skills">
  <div class="skills-header">
    <input #skillName placeholder="Название Навыка" />
    <button (click)="addSkill(skillName.value); skillName.value=''">
      Добавить
    </button>
  </div>
  <div class="bus_factors">
    <app-skill-item *ngFor="let skill of skills"
                       [skill]="skill"
                       [skillCount]="skillTeachedByEmployee[skill.id] ||  0"
                       (deleteButtonClick)="handleDeleteSkill($event)"
    >
    </app-skill-item>
  </div>
</div>

<div class="employees">
  <div class="employees-header">
    <input #employeeName placeholder="Сотрудник" />
    <button (click)="addEmployee(employeeName.value); employeeName.value=''">
      Добавить
    </button>
  </div>
  <div class="bus_factors">
    <app-employee-item *ngFor="let employee of employees"
                       [employee]="employee"
                       [skillCount]="employeesHasSkills[employee.id] ||  0"
                       (deleteButtonClick)="handleDeleteEmployee($event)"
    >
    </app-employee-item>
  </div>
</div>
